import Vue from 'vue'

const modulesFiles = require.context('@/components', true, /\.\/\w*\/index\.vue/)

modulesFiles.keys().filter(path => {
  const value = modulesFiles(path)
  const name = value.default.name
  name ? Vue.component(name, value.default) : Vue.component(value.default)
})
